/* MEDalign PDP — shared behaviour. Native custom elements, no dependencies.
   <pdp-countdown mode="midnight|evergreen|fixed" hours="24" minutes="10" end="2026-09-08T00:00" key="pdp-cd" loop>
     children with [data-h] [data-m] [data-s] (HH MM SS) and/or [data-ms] ("MM:SS")
   <pdp-date days="1" skip-sunday>  → "Thu, Sep 3rd" (today + days)
*/
const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

if (!customElements.get('pdp-countdown')) {
  class PdpCountdown extends HTMLElement {
    connectedCallback() {
      this.h = this.querySelector('[data-h]');
      this.m = this.querySelector('[data-m]');
      this.s = this.querySelector('[data-s]');
      this.ms = this.querySelector('[data-ms]');
      this.deadline = this.computeDeadline();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    computeDeadline() {
      const mode = this.getAttribute('mode') || 'midnight';
      const now = Date.now();
      if (mode === 'fixed') {
        const t = Date.parse(this.getAttribute('end') || '');
        return Number.isNaN(t) ? now : t;
      }
      if (mode === 'evergreen') {
        const hours = parseFloat(this.getAttribute('hours') || '0');
        const minutes = parseFloat(this.getAttribute('minutes') || '0');
        const span = (hours * 3600 + minutes * 60) * 1000 || 3600000;
        const key = this.getAttribute('key') || 'pdp-countdown';
        let start = 0;
        try { start = parseInt(localStorage.getItem(key) || '0', 10) || 0; } catch (e) { start = 0; }
        if (!start || start + span < now) {
          start = now;
          try { localStorage.setItem(key, String(start)); } catch (e) { /* private mode */ }
        }
        return start + span;
      }
      const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();   // midnight: next local 00:00
    }
    tick() {
      let total = this.deadline - Date.now();
      if (total <= 0) {
        if (this.hasAttribute('loop') || (this.getAttribute('mode') || 'midnight') === 'midnight') {
          if ((this.getAttribute('mode') || 'midnight') === 'evergreen') { try { localStorage.removeItem(this.getAttribute('key') || 'pdp-countdown'); } catch (e) {} }
          this.deadline = this.computeDeadline(); total = this.deadline - Date.now();
        } else { total = 0; }
      }
      const sec = Math.floor(total / 1000);
      const hh = Math.floor(sec / 3600), mm = Math.floor((sec % 3600) / 60), ss = sec % 60;
      if (this.h) this.h.textContent = pad(hh);
      if (this.m) this.m.textContent = pad(mm);
      if (this.s) this.s.textContent = pad(ss);
      if (this.ms) this.ms.textContent = pad(Math.floor(sec / 60)) + ':' + pad(ss);
    }
  }
  customElements.define('pdp-countdown', PdpCountdown);
}

if (!customElements.get('pdp-date')) {
  class PdpDate extends HTMLElement {
    connectedCallback() {
      const days = parseInt(this.getAttribute('days') || '0', 10);
      const d = new Date(); d.setDate(d.getDate() + days);
      if (this.hasAttribute('skip-sunday') && d.getDay() === 0) d.setDate(d.getDate() + 1);
      const wd = d.toLocaleDateString('en-US', { weekday: 'short' });
      const mo = d.toLocaleDateString('en-US', { month: 'short' });
      const n = d.getDate();
      const suf = (n % 10 === 1 && n !== 11) ? 'st' : (n % 10 === 2 && n !== 12) ? 'nd' : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
      this.textContent = `${wd}, ${mo} ${n}${suf}`;
    }
  }
  customElements.define('pdp-date', PdpDate);
}
